import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { LookupGetService } from '../../../shared/service/lookup-service/lookup-get.service';
import { ListColumn, ListDataColumn } from '../../../shared/ui/Data/ListColumn';
import { AuthService } from '../../../shared/service/auth-service/auth-service.service';
import { DateUtil } from '../../../shared/ui/DateUtil';
import { AbstractControl } from '@angular/forms';
import { Art57Section } from '../../../shared/ui/Art57Section/Art57Section';
import { MedicinalproductsService } from '../../../shared/service/medicinalproducts-service/medicinalproducts.service';

export class FieldDefinition {
  constructor(private injector: Injector) {}

  mahFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (O.4)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type_Org',
          type: 'select',
          hide: true,
          props: {
            label: 'Type',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('typeorg'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Type (O.1)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'name_Org',
          type: 'input',
          props: {
            label: 'MAH Name',

            disabled: true,
            attributes: {
              title: 'MAH Name (O.2)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'organisationsenderid',
          type: 'input',
          props: {
            label: 'MAH Sender ID',
            placeholder: '',

            disabled: true,
            attributes: {
              title: 'MAH Sender ID (O.5)',
            },
            lookup: {
              name: 'senderid',
            },
            readonly: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'sme_Status',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'SME status',
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('smestatus'),

                disabled: true,
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'SME Status (O.19)',
                },
              },
            },
          ],
        },
        {
          className: 'flex-1',
          key: 'sme_Number',
          type: 'input',
          props: {
            label: 'SME number',

            disabled: true,
            attributes: {
              title: 'SME Number (O.20)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'address',
          type: 'input',
          props: {
            label: 'Address',

            disabled: true,
            attributes: {
              title: 'Address (O.6)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'city',
          type: 'input',
          props: {
            label: 'City',

            disabled: true,
            attributes: {
              title: 'City (O.7)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'state',
          type: 'input',
          props: {
            label: 'State',

            disabled: true,
            attributes: {
              title: 'State (O.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'postcode',
          type: 'input',
          props: {
            label: 'Postcode',

            disabled: true,
            attributes: {
              title: 'Postcode (O.9)',
            },
          },
        },
        {
          key: 'countrycode',
          className: 'flex-1',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Country',
                disabled: true,
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('country'),
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'Country (O.10)',
                },
              },
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'tel_Number',
          type: 'input',
          props: {
            label: 'Telephone Number',

            disabled: true,
            attributes: {
              title: 'Tel Number (O.11)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'tel_Extension',
          type: 'input',
          props: {
            label: 'Telephone Extension',

            disabled: true,
            attributes: {
              title: 'Tel Extension (O.12)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'tel_Countrycode',
          type: 'input',
          props: {
            label: 'Telephone Country Code',

            disabled: true,
            attributes: {
              title: 'Tel Country Code (O.13)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'fax_Number',
          type: 'input',
          props: {
            label: 'Fax Number',

            disabled: true,
            attributes: {
              title: 'Fax Number (O.14)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'fax_Extension',
          type: 'input',
          props: {
            label: 'Fax Extension',

            disabled: true,
            attributes: {
              title: 'Fax Extension (O.15)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'fax_Countrycode',
          type: 'input',
          props: {
            label: 'Fax Country Code',

            disabled: true,
            attributes: {
              title: 'Fax Country Code (O.16)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'email',
          type: 'input',
          props: {
            label: 'E-mail Address',

            disabled: true,
            autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
            attributes: {
              title: 'E-mail Address (O.17)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',

            disabled: true,
            rows: 5,
            attributes: {
              title: 'Comment (O.18)',
            },
          },
        },
      ],
    },
    {
      key: 'validated',
    },
    {
      key: 'stamp_nullif',
    },
    {
      key: 'country',
    },
  ];

  sponsorField: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (O.4)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type_Org',
          type: 'select',
          props: {
            label: 'Type',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('typeorg'),
            valueProp: 'code',
            labelProp: 'name',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Type (O.1)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'name_Org',
          type: 'input',
          props: {
            label: 'Organisation Name',

            disabled: true,
            attributes: {
              title: 'Organisation Name (O.2)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'organisationsenderid',
          type: 'input',
          wrappers: ['modal-wrapper'],
          props: {
            label: 'Organisation Sender ID',
            placeholder: '',

            disabled: true,
            lookup: {
              name: 'senderid',
            },
            readonly: true,
            attributes: {
              title: 'Organisation Sender ID (O.5)',
            },
          },
          expressions: {
            'props.label': (field: FormlyFieldConfig) => {
              if (field.parent?.model.type_Org == 1) {
                return 'MAH Sender ID (O.5)';
              } else {
                return 'Sponsor Sender ID (O.5)';
              }
            },
            'props.lookup.description': (field: FormlyFieldConfig) => {
              if (field.parent?.model.type_Org == 1) {
                return 'Select MAH';
              } else {
                return 'Select Sponsor';
              }
            },
          },
        },
        {
          key: 'resolutionmode',
        },
        {
          key: 'name',
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'address',
          type: 'input',
          props: {
            label: 'Address',

            disabled: true,
            attributes: {
              title: 'Address (O.6)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'city',
          type: 'input',
          props: {
            label: 'City',

            disabled: true,
            attributes: {
              title: 'City (O.7)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'state',
          type: 'input',
          props: {
            label: 'State',

            disabled: true,
            attributes: {
              title: 'State (O.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'postcode',
          type: 'input',
          props: {
            label: 'Postcode',

            disabled: true,
            attributes: {
              title: 'Postcode (O.9)',
            },
          },
        },
        {
          key: 'countrycode',
          className: 'flex-1',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Country',
                disabled: true,
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('country'),
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'Country (O.10)',
                },
              },
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'tel_Number',
          type: 'input',
          props: {
            label: 'Telephone Number',

            disabled: true,
            attributes: {
              title: 'Tel Number (O.11)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'tel_Extension',
          type: 'input',
          props: {
            label: 'Telephone Extension',

            disabled: true,
            attributes: {
              title: 'Tel Extension (O.12)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'tel_Countrycode',
          type: 'input',
          props: {
            label: 'Telephone Country Code',

            disabled: true,
            attributes: {
              title: 'Tel Country Code (O.13)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'fax_Number',
          type: 'input',
          props: {
            label: 'Fax Number',

            disabled: true,
            attributes: {
              title: 'Fax Number (O.14)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'fax_Extension',
          type: 'input',
          props: {
            label: 'Fax Extension',

            disabled: true,
            attributes: {
              title: 'Fax Extension (O.15)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'fax_Countrycode',
          type: 'input',
          props: {
            label: 'Fax Country Code',

            disabled: true,
            attributes: {
              title: 'Fax Country Code (O.16)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'email',
          type: 'input',
          props: {
            label: 'E-mail Address',

            disabled: true,
            autocomplete: 'PLEASE_DO_NOT_AUTOCOMPLETE',
            attributes: {
              title: 'E-mail Address (O.17)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            disabled: true,
            label: 'Comment',
            rows: 5,
            attributes: {
              title: 'Comment (O.18)',
            },
          },
        },
      ],
    },
    {
      key: 'validated',
    },
    {
      key: 'stamp_nullif',
    },
    {
      key: 'country',
    },
  ];

  qppvField: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'maskedQppvCode',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'QPPV Code',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'name',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'First Name',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'family',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Last Name',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'email',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EMail',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'roledesc',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Role',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'responsible',
          type: 'select',
          props: {
            label: 'Is Responsible',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'qppv',
          type: 'select',
          props: {
            label: 'Is QPPV',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'isenabled',
          type: 'select',
          props: {
            label: 'Is Enabled',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
          },
        },
      ],
    },
    /* REMOVED FOR INDUSTRY VERSION (requested by veronika baker in refiment session - 23/06/2025)
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'req_status',
          type: 'select',
          props: {
            label: 'Request Status',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('req_status'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
          },
        },
      ],
    },
    */
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'orgid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Organisation ID',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'org_name',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Organisation Name',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'department',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Department',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'title',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Title',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'street',
          type: 'input',
          props: {
            label: 'Street',
            disabled: true,
            readonly: true,
          },
        },
        {
          className: 'flex-1',
          key: 'city',
          type: 'input',
          props: {
            label: 'City',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'state',
          type: 'input',
          props: {
            label: 'State',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'countrycode',
          className: 'flex-1',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Country',
                readonly: true,
                disabled: true,
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('country'),
                valueProp: 'code',
                labelProp: 'name',
              },
              expressionProperties: {
                //This is needed for datamasking
                'props.options': (model, formState, field) => {
                  if (field!.formControl?.value == '0') {
                    return [{ code: '0', name: '***' }];
                  } else {
                    return this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('country');
                  }
                },
              },
            },
          ],
        },
        {
          className: 'flex-1',
          key: 'postcode',
          type: 'input',
          props: {
            label: 'Postcode',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'telcountry',
          type: 'input',
          props: {
            label: 'Phone Country Code',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'telnumber',
          type: 'input',
          props: {
            label: 'Phone Number',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'telext',
          type: 'input',
          props: {
            label: 'Phone Extension',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'faxcountry',
          type: 'input',
          props: {
            label: 'Fax Country Code',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'faxnumber',
          type: 'input',
          props: {
            label: 'Fax Number',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'faxext',
          type: 'input',
          props: {
            label: 'Fax Extension',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'mobcountry',
          type: 'input',
          props: {
            label: 'Mobile Country Code',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'mobnumber',
          type: 'input',
          props: {
            label: 'Mobile Number',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
  ];

  atccodeField: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'atccode',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'ATC Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'ATC Code (ST.ATC.2)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type_Term',
          type: 'select',
          props: {
            label: 'Type',

            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('type_Term'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Type (ST.ATC.1)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'deprecated',
          type: 'select',
          props: {
            label: 'Deprecated',

            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('yesNo'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Deprecated',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'atccode_Desc',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'ATC Code Description',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'ATC Code Description (ST.ATC.4)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'versiondate',
          defaultValue: '',
          type: 'dateType',
          props: {
            label: 'Version Date',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Version Date (ST.ATC.6)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',
            rows: 5,

            disabled: true,
            attributes: {
              title: 'Comment (ST.ATC.7)',
            },
          },
        },
      ],
    },
  ];

  abstractPharmaceuticalProductField: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'scientificname',
          type: 'input',
          props: {
            label: 'Scientific Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Name',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'scientificcode',
          type: 'input',
          props: {
            label: 'Scientific Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Code',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'scientificstrength',
          type: 'input',
          props: {
            label: 'Scientific Strength',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Strength',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'name_pharmform',
          type: 'input',
          props: {
            label: 'Scientific Pharmaceutical Form Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Pharmaceutical Form Name',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_development',
          type: 'select',
          props: {
            label: 'Type',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substancestypes'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Type',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ismanuallydesc',
          type: 'select',
          props: {
            label: 'Is Manually Created',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Is Manually Created',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'wasmanuallydesc',
          type: 'select',
          props: {
            label: 'Was Manually Created',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Was Manually Created',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'inmanuallydesc',
          type: 'select',
          props: {
            label: 'Part of one Manually Created',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Part of one Manually Created',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'created_stamp',
          type: 'datetimeType',
          props: {
            label: 'Created (Date/Time)',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Created (Date/Time)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'status',
          type: 'select',
          props: {
            label: 'Status',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('pispStatus'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Status can be Active or Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
  ];

  scientificProducts: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'scientificname',
          type: 'input',
          props: {
            label: 'Scientific Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Name',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'scientificcode',
          type: 'input',
          props: {
            label: 'Scientific Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Code',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'scientificstrength',
          type: 'input',
          props: {
            label: 'Scientific Strength',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Strength',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'name_pharmform',
          type: 'input',
          props: {
            label: 'Scientific Pharmaceutical Form Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Scientific Pharmaceutical Form Name',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ownerhqid',
          type: 'input',
          props: {
            label: 'Owner HQ ID',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ ID',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_development',
          type: 'select',
          props: {
            label: 'Type',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substancestypes'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Type',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'status',
          type: 'select',
          props: {
            label: 'Status',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('pispStatus'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Status can be Active or Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
  ];

  reportingNameField: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_code',
          type: 'input',
          props: {
            label: 'Product Index EV Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Product Index EV Code',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'productnamevariation',
          type: 'input',
          props: {
            label: 'Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Name',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type',
          type: 'select',
          props: {
            label: 'Name Type',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('nameTypeProductIndex'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Name Type',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'created_stamp',
          type: 'datetimeType',
          props: {
            label: 'Created (When)',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Created (When)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          type: 'input',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'status',
          type: 'select',
          props: {
            label: 'Status',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('pispStatus'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Status can be Active or Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'full_presentation',
          type: 'select',
          props: {
            label: 'Is a Full Presentation',
            readonly: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            attributes: {
              title: 'Is a Full Presentation',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'cap_flag',
          type: 'select',
          props: {
            label: 'Linked to a CAP',
            readonly: true,
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Linked to a CAP',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_substance',
          type: 'select',
          props: {
            label: 'Linked to a Substance',
            readonly: true,
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Linked to a Substance',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'show_in_lookup',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Show in Lookup',
            readonly: true,
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Show in Lookup',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'numref',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Num Products (Presentations)',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Num Products (Presentations)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'numsciref',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Num Products (Scientific)',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Num Products (Scientific)',
            },
          },
        },
      ],
    },
  ];

  mptField: FormlyFieldConfig[] = [
    {
      key: 'producttypecode',
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'value',
          type: 'select',
          className: 'flex-1',
          props: {
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('medicinalproducttype'),
            valueProp: 'code',
            labelProp: 'name',
            label: 'Medicinal Product Type',
            readonly: true,
            disabled: true,
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },
  ];

  sourceField: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'sourcename',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Source Name',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Source Name (S.3)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (S.2)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ownerid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner Identifier',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner HQ Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            disabled: true,
            label: 'Comment',
            rows: 5,
            attributes: {
              title: 'Comment (S.4)',
            },
          },
        },
      ],
    },
    {
      key: 'validated',
    },
    {
      key: 'stamp_nullif',
    },
  ];

  pharmaceuticalFormFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (ST.PF.3)',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type_Term',
          type: 'select',
          props: {
            label: 'Type',

            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('type_Term'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Type (ST.PF.1)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'deprecated',
          type: 'select',
          props: {
            label: 'Deprecated',

            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('yesNo'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Deprecated',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'name_Pharmform',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Pharmaceutical Form Name',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Pharmaceutical Form Name (ST.PF.5)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'versiondate',
          defaultValue: '',
          type: 'dateType',
          props: {
            label: 'Version Date',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Version Date (ST.PF.7)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'previous_ev_code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Previous EV Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Previous EV Code (ST.PF.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ownerid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Owner Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner Identifier',
            },
          },
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
        },
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Owner HQ Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Comment',
            rows: 5,

            disabled: true,
            attributes: {
              title: 'Comment (ST.PF.9)',
            },
          },
        },
      ],
    },
  ];

  roaFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (ST.AR.3)',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type_Term',
          type: 'select',
          props: {
            label: 'Type',

            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('type_Term'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Type (ST.AR.1)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'deprecated',
          type: 'select',
          props: {
            label: 'Deprecated',

            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('yesNo'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: 'Deprecated',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'name_Admroute',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Administration Route Name',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Administration Route Name (ST.AR.5)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'versiondate',
          defaultValue: '',
          type: 'dateType',
          props: {
            label: 'Version Date',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Version Date (ST.AR.7)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'previous_Ev_Code',
          type: 'input',
          props: {
            label: 'Previous EV Code',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Previous EV Code (ST.AR.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'newownerid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Owner Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner Identifier',
            },
          },
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
        },
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Owner HQ Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',
            rows: 5,

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Comment (ST.AR.9)',
            },
          },
        },
      ],
    },
  ];

  attachmentFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ownerid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Owner Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner Identifier',
            },
          },
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
        },
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Owner HQ Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'datesent',
          defaultValue: '',
          type: 'datetimeType',
          props: {
            label: 'Created',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Created',
            },
          },
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'attachmenttype',
          type: 'select',
          props: {
            label: 'Type',
            defaultValue: null,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('attachmenttype'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Type (ATT.5)',
            },
          },
          hooks: {
            onInit: (field) => {
              let previousValue: any = undefined;
              field.formControl?.valueChanges.subscribe((newValue: any) => {
                if (field.formControl?.value != previousValue) {
                  // TODO:   field type control (PPI/PSI)
                  let filetype =
                    field.parent!.parent!.fieldGroup![5].fieldGroup![2]; // this refers to filetype field
                  const currentValue = filetype.formControl!.value;

                  if (field.formControl?.value == 1) {
                    filetype.props!['options'] = this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('ppiattachmentfiletype');
                    filetype.formControl!.setValue(
                      currentValue ? currentValue : 1,
                    );
                  } else if (field.formControl?.value == 2) {
                    filetype.props!['options'] = this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('psiattachmentfiletype');
                    filetype.formControl!.setValue(
                      currentValue ? currentValue : null,
                    );
                  } else {
                    filetype.formControl!.setValue(
                      currentValue ? currentValue : null,
                    );
                  }

                  previousValue = newValue;
                }
              });
              field.formControl!.setValue(field.formControl!.value);
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'id',
          type: 'documentViewType',
          props: {
            label: 'Attachment File',
          },
        },
        {
          className: 'flex-1',
          key: 'attachmentname',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Attachment Name',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Attachment name (ATT.4) The name of the attachment given by the sender should be specified.',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'filetypedesc',
          type: 'input',
          props: {
            label: 'File Type',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'File Type (ATT.3)',
            },
          },
        },
      ],
    },

    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'languagecode',
          type: 'select',
          props: {
            label: 'Language',
            defaultValue: null,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('language'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Select the appropriate language of the attachment (ATT.6)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'languagecode2',
          type: 'select',
          props: {
            label: '2nd Language',
            defaultValue: null,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('language'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Select the second language of the attachment (ATT.7)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'attachmentversion',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Version Number',

            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Enter up to 2 characters to identify your version of this attachment (ATT.8)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'attachmentversiondateview',
          type: 'datetime',
          props: {
            label: 'Version Date',
            keys: ['versiondateformat', 'attachmentversiondate'],
            disabled: true,
            readonly: true,
            attributes: {
              title:
                'Enter the date this version of the attachment was created (ATT.9)',
            },
          },
          validators: {
            customValidator: {
              expression: (control: any) => {
                let value = new Date();
                let today = new Date();
                if (control.value) {
                  if (
                    control.parent.controls.versiondateformat.value == '102'
                  ) {
                    const [dd, mm, yyyy] = control.value.split('/').map(Number);
                    value = new Date(yyyy, mm - 1, dd);
                    today = new Date();
                  } else {
                    const [mm, yyyy] = control.value.split('/').map(Number);
                    value = new Date(yyyy, mm - 1);
                    today = new Date();
                  }
                }

                return control.value == undefined || value <= today;
              },
              message: () => 'Date cannot be higher than today',
            },
          },
        },
        {
          key: 'attachmentversiondate',
          expressionProperties: {
            'model.attachmentversiondateview': (model) =>
              model && model.attachmentversiondateview === undefined
                ? DateUtil.importDate(
                    model.attachmentversiondate,
                    model.versiondateformat,
                  )
                : model == undefined ||
                    model.attachmentversiondateview === undefined
                  ? undefined
                  : model.attachmentversiondateview,
          },
        },
        {
          key: 'versiondateformat',
        },
      ],
    },
    {
      // to be used in substance attachments listview
      key: 'filename',
      defaultValue: '',
    },
  ];

  mflFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
          hideExpression: (model, formState, field) => {
            return (
              !this.injector.get(AuthService).isEMAOrganisation() &&
              field?.parent?.model.ownerhqid !==
                this.injector.get(AuthService).getPrincipal().organisation
                  .organisationIdHQ
            );
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
          hideExpression: (model, formState, field) => {
            return (
              !this.injector.get(AuthService).isEMAOrganisation() &&
              field?.parent?.model.ownerhqid !==
                this.injector.get(AuthService).getPrincipal().organisation
                  .organisationIdHQ
            );
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (MF.2)',
            },
          },
          hideExpression: (model, formState, field) => {
            return field!.parent!.model.operationtype === 1;
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ownerid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner Identifier',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner HQ Identifier',

            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'mflcompany',
          type: 'input',
          props: {
            label: 'Company',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Company (MF.3)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'mfldepartment',
          type: 'input',
          props: {
            label: 'Department',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Department (MF.4)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'mflbuilding',
          type: 'input',
          props: {
            label: 'Building',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Building (MF.5)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'mflstreet',
          type: 'input',
          props: {
            label: 'Street',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Street (MF.6)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'mflcity',
          type: 'input',
          props: {
            label: 'City',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'City (MF.7)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'mflstate',
          type: 'input',
          props: {
            label: 'State',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'State (MF.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'mflpostcode',
          type: 'input',
          props: {
            label: 'Postcode',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Postcode (MF.9)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'country',
          fieldGroup: [
            {
              key: 'name',
              type: 'input',
              props: {
                label: 'Country',
                readonly: true,
                disabled: true,
                attributes: {
                  title: 'Country (MF.10)',
                },
              },
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',
            readonly: true,
            disabled: true,
            rows: 5,
            attributes: {
              title: 'Comment (MF.11)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'masterfiledesc',
          type: 'input',
          hide: true,
        },
      ],
    },
  ];

  authorisedProductFields: FormlyFieldConfig[] = [
    {
      key: 'id',
    },
    {
      key: 'revision',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (AP.2)',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'version',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Version',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type_product',
          type: 'select',
          props: {
            label: 'Type',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('productstypes'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_ema',
          defaultValue: '',
          type: 'select',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Is Ema Owned',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_legacy',
          defaultValue: '',
          type: 'select',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Is Legacy',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_linked',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Is Linked',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'product_version_status',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Version Status',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('productstatus'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'product_version_validity',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Version Validity',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('productversion'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'versionDesc',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Version Description',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'product_validity',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Product Validity',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('validityValues'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'product_pending',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Product Pending',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('pendingValues'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'product_nullified',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Product Nullified',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'versionDate',
          defaultValue: '',
          type: 'datetimeType',
          props: {
            label: 'Version Date',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'versionBy',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Version By',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'newVersionDate',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'New Version Date',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'newVersionBy',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'New Version By',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          type: 'nullifiedNoDatetimeType',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner HQ Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      key: 'mflcode',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'value',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Master File Location EV Code',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'enquiryemail',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'PhV enquiry email',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'PhV enquiry email (AP.7)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'enquiryphone',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'phone',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'PhV enquiry Phone (AP.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'senderlocalcode',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Sender Local Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Sender Local Code (AP.9)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'infodate',
          defaultValue: '',
          type: 'dateType',
          props: {
            label: 'Info Date',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Info Date (AP.11)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'authorisationcountrycode',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Authorisation Country Code',
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('country'),
                disabled: true,
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'Country where the product is authorised (AP.12.1)',
                },
              },
            },
          ],
        },
        {
          className: 'flex-1',
          key: 'authorisationprocedure',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Authorisation Procedure',
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('authorisationprocedure'),
                disabled: true,
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title:
                    'You can choose one of the procedures the product was authorised with (AP.12.2)',
                },
              },
            },
          ],
        },
        {
          className: 'flex-1',
          key: 'authorisationstatus',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Authorisation Status',
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('authorisationstatus'),
                disabled: true,
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'Authorisation Status (AP.12.3)',
                },
              },
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'authorisationnumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Authorisation Number',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Authorisation number as granted by regulatory authorities (AP.12.4)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'authorisationdate',
          defaultValue: '',
          type: 'dateType',
          props: {
            label: 'Authorisation/Renewal Date',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Authorisation/Renewal Date (AP.12.5)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'mrpnumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'MRP/DCP/EMEA Number',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Authorisation number for an MRP/DCP/EMEA product (AP.12.7)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'eunumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EU Number',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Authorisation number for a centrally authorized product (AP.12.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'legalbasis',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Legal Basis',
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('legalbasis'),
                disabled: true,
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'Legal Basis (AP.12.13)',
                },
              },
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'orphandrug',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Orphan Drug',
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('orphanDrug'),
                disabled: true,
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'Orphan Drug Status (AP.12.9)',
                },
              },
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'intensivemonitoring',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                label: 'Additional Monitoring',
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('additionalMonitoring'),
                disabled: true,
                valueProp: 'code',
                labelProp: 'name',
                attributes: {
                  title: 'Additional Monitoring (AP.12.10)',
                },
              },
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'withdrawndate',
          defaultValue: '',
          type: 'dateType',
          props: {
            label: 'Invalidated Date',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Invalidated Date (AP.12.12)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'productname',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Full Presentation Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Name for the product as authorized (AP.13.1)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'productshortname',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Product Short Name',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Invented name or common scientific name  in the full presentation name (AP.13.2)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'productgenericname',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Product INN/Common Name',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'INN/Common name if it is present in the full presentation name (AP.13.3)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'productcompanyname',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Product Company Name',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Company name if it is present in the  full presentation name (AP.13.4)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'productstrength',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Product Strength Name',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Strength if it is present in the full presentation name (AP.13.5)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'productform',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Product Form Name',
            readonly: true,
            disabled: true,
            attributes: {
              title:
                'Pharmaceutical form if it is present in the full presentation name (AP.13.6)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'packagedesc',
          defaultValue: '',
          type: 'textarea',
          props: {
            rows: 5,
            label: 'Package Description',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Package Description (AP.13.7)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',
            disabled: true,
            rows: 5,
            attributes: {
              title: 'Comment (AP.14)',
            },
          },
        },
      ],
    },
    {
      key: 'validated',
    },
  ];

  developmentProductFields: FormlyFieldConfig[] = [
    {
      key: 'id',
    },
    {
      key: 'revision',
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (DP.2)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'version',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Version',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type_product',
          type: 'select',
          props: {
            label: 'Type',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('productstypes'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_ema',
          defaultValue: '',
          type: 'select',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Is Ema Owned',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_transition',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Interim Format',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('interimPrepost'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_legacy',
          defaultValue: '',
          type: 'select',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Is Legacy',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'is_linked',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Is Linked',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'product_version_status',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Version Status',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('productstatus'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'product_version_validity',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Version Validity',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('productversion'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'versionDesc',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Version Description',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'product_validity',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Product Validity',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('validityValues'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'product_pending',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Product Pending',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('pendingValues'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'product_nullified',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Product Nullified',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('binaryYesNo'),
            valueProp: 'code',
            labelProp: 'name',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'versionDate',
          defaultValue: '',
          type: 'datetimeType',
          props: {
            label: 'Version Date',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'versionBy',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Version By',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'newVersionDate',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'New Version Date',
            readonly: true,
            disabled: true,
          },
        },
        {
          className: 'flex-1',
          key: 'newVersionBy',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'New Version By',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          type: 'nullifiedNoDatetimeType',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner HQ Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'productcode',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Product Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Code for the product (DP.6)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'senderlocalcode',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Sender Local Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Sender Local Code (DP.4)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'productname',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Product Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Name for the Product (DP.6)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'productothername',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Product Other Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Product Other Name (DP.6)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',
            disabled: true,
            rows: 5,
            attributes: {
              title: 'Comment (DP.7)',
            },
          },
        },
      ],
    },
    {
      key: 'validated',
    },
  ];

  approvedSubstanceFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type',
          type: 'select',
          props: {
            label: 'Type',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substancestypes'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (AS.2)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'newownerid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner Identifier',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner HQ Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substancename',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Substance Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Name of the substace (AS.4)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substanceclass',
          type: 'select',
          props: {
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substanceclass'),
            label: 'Class',
            readonly: true,
            disabled: true,
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title:
                'You may Classify the Substance using a value from the Lookup List (AS.7)',
            },
          },
        },
      ],
    },
    {
      key: 'sourcecode',
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'value',
        },
        {
          className: 'flex-1',
          key: 'name',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Source Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'casnumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'CAS Number',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'CAS Number (AS.5)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'molecularformula',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Molecular Formula',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Molecular Formula (AS.6)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'cbd',
          type: 'textarea',
          props: {
            label: 'Chemical / Biological Description',
            placeholder: '',
            rows: 5,
            disabled: true,
            readonly: true,
            attributes: {
              title: 'Chemical / Biological Description (AS.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',
            disabled: true,
            rows: 5,
            attributes: {
              title: 'Comment (As.10)',
            },
          },
        },
      ],
    },
  ];

  developmentSubstanceFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'validated',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Validity',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Validity',
            },
          },
        },
      ],
    },
    {
      key: 'localnumber',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'stamp_nullif',
          defaultValue: '',
          type: 'yesNoDatetimeType',
          props: {
            label: 'Nullified',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Nullified',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type',
          type: 'select',
          props: {
            label: 'Type',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substancestypes'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code (DS.2)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'newownerid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner Identifier',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'ownerhqid',
          defaultValue: '',
          type: 'input',
          hideExpression: () => {
            return !this.injector.get(AuthService).isEMAOrganisation();
          },
          props: {
            label: 'Owner HQ Identifier',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Owner HQ Identifier',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substancename',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Current Name or Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'iscode',
          type: 'select',
          props: {
            label: 'Is Name or Code',
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substancenameorcode'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substanceclass',
          type: 'select',
          props: {
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substanceclass'),
            label: 'Class',
            readonly: true,
            disabled: true,
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title:
                'You may Classify the Substance using a value from the Lookup List (DS.7)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'casnumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'CAS Number',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'CAS Number (AS.5)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'molecularformula',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Molecular Formula',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Molecular Formula (AS.6)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'cbd',
          type: 'textarea',
          props: {
            label: 'Chemical / Biological Description',
            placeholder: '',
            rows: 5,
            disabled: true,
            readonly: true,
            attributes: {
              title: 'Chemical / Biological Description (AS.8)',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'comments',
          type: 'textarea',
          props: {
            label: 'Comment',
            disabled: true,
            rows: 5,
            attributes: {
              title: 'Comment (DS.9)',
            },
          },
        },
      ],
    },
  ];

  substanceCodeNameFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substancename',
          type: 'input',
          props: {
            label: 'Substance Name or Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Substance Name or Code',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'iscode',
          type: 'select',
          props: {
            label: 'Is Name or Code',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('substancenameorcode'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Is Name or Code',
            },
          },
        },
      ],
    },
  ];

  substanceTranslationFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'languagecode',
          type: 'select',
          props: {
            label: 'Language',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('language'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Is Name or Code',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'term',
          type: 'input',
          props: {
            label: 'Translation',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Translation of the substance (AS.T.2)',
            },
          },
        },
      ],
    },
  ];

  substanceAliasFields: FormlyFieldConfig[] = [
    {
      key: 'sourcecode',
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'value',
        },
        {
          className: 'flex-1',
          key: 'name',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Source Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'aliasname',
          type: 'input',
          props: {
            label: 'Alias Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'A different name describing a substance (AS.SA.2)',
            },
          },
        },
      ],
    },
  ];

  substanceInternationalCodeFields: FormlyFieldConfig[] = [
    {
      key: 'sourcecode',
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'value',
        },
        {
          className: 'flex-1',
          key: 'name',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Source Name',
            readonly: true,
            disabled: true,
            attributes: {
              title: '',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substancename',
          type: 'input',
          props: {
            label: 'International Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'International Code of the Substance (AS.IC.2)',
            },
          },
        },
      ],
    },
  ];

  substancePreviousEvCodeFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'devevcode',
          fieldGroup: [
            {
              type: 'input',
              key: 'value',
              props: {
                label: 'Previous EV Code',
                readonly: true,
                disabled: true,
              },
            },
          ],
        },
      ],
    },
  ];

  substanceParentCodeFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'sourcecode',
          fieldGroup: [
            {
              key: 'value',
              type: 'select',
              props: {
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('substancetype'),
                label: 'Substance Type',
                disabled: true,
                readonly: true,
                valueProp: 'code',
                labelProp: 'name',
              },
            },
            {
              key: 'name',
            },
            {
              key: 'resolutionmode',
              defaultValue: 2,
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'referencetext',
          fieldGroup: [
            {
              key: 'value',
              type: 'input',
              wrappers: ['modal-wrapper'],
              props: {
                label: 'Parent Substance Name',
                placeholder: '',
                disabled: true,
                readonly: true,
                lookup: {
                  name: 'substanceparentcode',
                  description: 'Select Substance',
                  type: 'LR',
                  columns: [
                    new ListColumn('Num', ListDataColumn.TEXT, 'num'),
                    new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
                    new ListColumn(
                      'Substance Name',
                      ListDataColumn.TEXT,
                      'name',
                    ),
                    new ListColumn(
                      'Class',
                      ListDataColumn.TEXT,
                      'classification',
                    ),
                  ],
                },
              },
            },
            {
              key: 'name',
            },
            {
              key: 'resolutionmode',
            },
          ],
        },
      ],
    },
  ];
  productIndicationItemFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          type: 'select',
          key: 'meddraversion',
          props: {
            label: 'Meddra version',
            readonly: true,
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('supportedbacklogmeddraversions'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title:
                'During an insert or an update of an AMP, each indication should be coded using MedDRA in its latest current version. The next official MedDRA version can also be referenced. (AP.IND.1/DP.IND.1)',
            },
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },

    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          type: 'select',
          key: 'meddralevel',
          props: {
            label: 'Meddra level',
            readonly: true,
            disabled: true,
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('meddraLevel'),
            valueProp: 'code',
            labelProp: 'name',
            attributes: {
              title:
                'Low Level Term (LLT) must be selected. (AP.IND.2/DP.IND.2)',
            },
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },

    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-4 ml-5',
          key: 'meddracode',
          fieldGroup: [
            {
              type: 'input',
              key: 'value',
              wrappers: ['modal-wrapper'],
              props: {
                lookup: {},
                label: 'Meddra term',
                readonly: true,
                disabled: true,
                attributes: {
                  title:
                    'MedDRA terms corresponding to the description of the authorised indication(s), signs, symptoms or intended effects as reflected in Section 4.1 Therapeutic Indications of the SmPC must be specified. (AP.IND.3/DP.IND.3)',
                },
              },
            },
            {
              key: 'name',
            },
            {
              key: 'resolutionmode',
            },
          ],
        },
      ],
    },
  ];

  productPreviousEvCodeFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'type',
          type: 'select',
          props: {
            label: 'Type',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('productstypes'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Type',
            },
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'devevcode',
          fieldGroup: [
            {
              type: 'input',
              key: 'value',
              props: {
                label: 'Previous EV Code',
                readonly: true,
                disabled: true,
              },
            },
          ],
        },
      ],
    },
  ];

  pharmaceuticalFormCodeItem: FormlyFieldConfig[] = [
    {
      key: 'pharmformcode',
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'value',
          type: 'input',
          className: 'flex-1',
          wrappers: ['modal-wrapper'],
          props: {
            lookup: {
              name: 'pharmform',
              description: 'Select Pharmaceutical Form',
              type: 'LR',
              columns: [
                new ListColumn('Num', ListDataColumn.TEXT, 'num'),
                new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
                new ListColumn('Name', ListDataColumn.TEXT, 'name'),
                new ListColumn('Type', ListDataColumn.TEXT, 'type'),
              ],
            },
            label: 'Administrable Pharmaceutical Form',
            disabled: true,
            readonly: true,
          },
        },
        {
          key: 'resolutionmode',
        },
        {
          key: 'name',
        },
      ],
    },
  ];

  pharmaceuticalProductMedicalDeviceItemFields: FormlyFieldConfig[] = [
    {
      key: 'medicaldevicecode',
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          type: 'select',
          key: 'value',
          props: {
            label: 'Medical Device',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('medicaldevice'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            readonly: true,
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },
  ];

  drugIngredientItemFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substancecode',
          fieldGroup: [
            {
              type: 'input',
              key: 'value',
              wrappers: ['modal-wrapper'],
              props: {
                label: 'Substance',
                lookup: {
                  name: 'substance',
                  description: 'Select Substance',
                  type: 'LR',
                  parameters: null,
                  columns: [
                    new ListColumn('Num', ListDataColumn.TEXT, 'num'),
                    new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
                    new ListColumn(
                      'Substance Name',
                      ListDataColumn.TEXT,
                      'name',
                    ),
                    new ListColumn('Type', ListDataColumn.TEXT, 'type'),
                    new ListColumn('Language', ListDataColumn.TEXT, 'language'),
                    new ListColumn(
                      'Validated',
                      ListDataColumn.DATE,
                      'validated',
                    ),
                  ],
                },
                disabled: true,
                readonly: true,
                attributes: {
                  title:
                    'The substance name of the ingredient(s) indicated as active/excipient/adjuvant in line with the description of the ingredients referenced in the SmPC must be specified as per guidance described in Chapter 3.II. (PP.ACT.1/PP.EXC.1/PP.ADJ.1)',
                },
              },
              expressions: {
                'props.lookup.parameters': (field: FormlyFieldConfig) => {
                  if (
                    this.injector.get(Art57Section).getSelectedSection()
                      .selectedNode.parent?.parent?.parent?.parent?.data.model
                      .type == 2
                  ) {
                    //Authorised
                    return [['type', 2]];
                  } else {
                    //Development
                    //No filters needed
                    return null;
                  }
                },
              },
            },
            {
              key: 'name',
            },
            {
              key: 'resolutionmode',
              defaultValue: 2,
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'roleofingredient',
          type: 'radio',
          props: {
            label: 'Role of Ingredient',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('roleofingredient'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            readonly: true,
            attributes: {
              title: 'Role of Ingredient (PP.ACT/PP.EXC/PP.ADJ)',
            },
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'ingredientStrengthInformation',
          className: 'flex-1',
          template:
            '<div><strong>Ingredient Strength Information<strong></div><br>',
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'concentrationtypecode',
          fieldGroup: [
            {
              type: 'select',
              key: 'value',
              props: {
                options: this.injector
                  .get(LookupGetService)
                  .loadCachedOptions('amountvaluetype'),
                valueProp: 'code',
                labelProp: 'name',
                label: 'Amount Value Type',
                disabled: true,
                readonly: true,
                attributes: {
                  title:
                    "You can choose Equal, 'Not less than', 'Range', 'Up to' or 'Approximately' (PP.ACT.2/PP.EXC.2/PP.ADJ.2)",
                },
              },
              validators: {
                customValidator: {
                  expression: (
                    control: AbstractControl,
                    field: FormlyFieldConfig,
                  ) => {
                    if (
                      field.parent?.parent?.parent &&
                      field.parent.parent.parent.fieldGroup![1].fieldGroup![0]
                        .model.roleofingredient
                    ) {
                      field.props!['required'] = !(
                        field.parent.parent.parent.fieldGroup![1].fieldGroup![0]
                          .model.roleofingredient == 2
                      );
                    }
                    return true;
                  },
                },
              },
              hooks: {
                onInit: (field) => {
                  const updateTemplate = () => {
                    const selectedOption = field.formControl?.value;
                    let newTemplate = '';
                    let newTemplateUpper = '';
                    const parentField = field?.parent?.parent?.parent;
                    const firstSectionLabelField =
                      parentField!.fieldGroup![4].get!('firstSectionLabel');
                    const secondSectionLabelField =
                      parentField!.fieldGroup![5].get!('secondSectionLabel');

                    switch (selectedOption) {
                      case 5:
                        newTemplate =
                          '<div><strong>Approximate Value</strong></div><br>';
                        break;
                      case 6:
                        newTemplate =
                          '<div><strong>Average Value</strong></div><br>';
                        break;
                      case 1:
                        newTemplate =
                          '<div><strong>Exact Value</strong></div><br>';
                        break;
                      case 4:
                        newTemplate =
                          '<div><strong>Minimum Value</strong></div><br>';
                        break;
                      case 2:
                        newTemplate =
                          '<div><strong>Low Limit</strong></div><br>';
                        newTemplateUpper =
                          '<div><strong>Upper Limit</strong></div><br>';
                        break;
                      case 3:
                        newTemplate =
                          '<div><strong>Maximum Value</strong></div><br>';
                        break;
                    }

                    if (firstSectionLabelField) {
                      firstSectionLabelField.template = newTemplate;
                    }

                    if (secondSectionLabelField) {
                      secondSectionLabelField.template = newTemplateUpper;
                    }
                  };

                  field.formControl?.valueChanges.subscribe(updateTemplate);

                  updateTemplate();
                },
              },
              expressionProperties: {
                //This is needed for datamasking
                'props.options': (model, formState, field) => {
                  if (field!.formControl?.value === 0) {
                    return [{ code: 0, name: '***' }];
                  } else {
                    return this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('amountvaluetype');
                  }
                },
              },
            },
            {
              key: 'name',
            },
            {
              key: 'resolutionmode',
            },
          ],
        },
        {
          className: 'flex-1',
          type: 'select',
          key: 'expressedAs',
          props: {
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('strength'),
            valueProp: 'code',
            labelProp: 'name',
            label: 'Expressed as',
            disabled: true,
            readonly: true,
          },
          hideExpression: (model, formState, field) => {
            return (
              field?.parent?.model.concentrationtypecode?.value == null ||
              field?.parent?.model.concentrationtypecode?.name == ''
            );
          },
          expressionProperties: {
            'props.options': (model, formState, field) => {
              if (
                model.concentrationtypecode &&
                model.concentrationtypecode.value == 0
              ) {
                return [{ code: 0, name: '***' }];
              } else {
                return field!.props!['options'];
              }
            },
            'model.expressedAs': (
              model,
              formState,
              field?: FormlyFieldConfig,
            ) => {
              const lowAmountDenomunitValue =
                model.lowAmountConditionalGroup?.lowamountdenomunit?.value;
              let result = model.expressedAs ? model.expressedAs : null;
              if (lowAmountDenomunitValue && result == null) {
                // try to load from unitofmeasurement
                let lookupNameToCheck = 'unitofmeasurement';
                if (
                  this.injector
                    .get(LookupGetService)
                    .retrieveValueFromCache(
                      lookupNameToCheck,
                      lowAmountDenomunitValue,
                    ) != ''
                ) {
                  result = 1;
                } else {
                  lookupNameToCheck = 'unitofpresentation';
                  if (
                    this.injector
                      .get(LookupGetService)
                      .retrieveValueFromCache(
                        lookupNameToCheck,
                        lowAmountDenomunitValue,
                      ) != ''
                  ) {
                    result = 2;
                  }
                }
              }

              return result == null ? 0 : result;
            },
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },
    {
      key: 'lowAmountConditionalGroup',
      hideExpression: (model, formState, field) => {
        return (
          field?.parent?.model.concentrationtypecode?.value == null ||
          field?.parent?.model.concentrationtypecode?.name == ''
        );
      },
      // fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'firstSectionLabel',
              className: 'flex-1',
              template: '<div>space reserved</div>',
            },
          ],
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              className: 'flex-1',
              type: 'masked-input',
              key: 'lowamountnumervalue',
              props: {
                label: 'Numerator Value',
                disabled: true,
                readonly: true,
                maskChar: '*',
                maskIf: (field: any) => {
                  return (
                    field.parent?.parent?.parent?.model.concentrationtypecode
                      .value == 0
                  );
                },
                attributes: {
                  title:
                    'The Low Limit Numerator Value or for non range measurements the Numerator Value (PP.ACT.3/PP.EXC.3/PP.ADJ.3)',
                },
              },
            },
            {
              className: 'flex-1',
              key: 'lowamountnumerprefix',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('amountprefix'),
                    label: 'Numerator Prefix',
                    disabled: true,
                    readonly: true,
                    valueProp: 'code',
                    labelProp: 'name',
                    attributes: {
                      title:
                        'The Low Limit Numerator Prefix or for non range measurements the Numerator Prefix (PP.ACT.4/PP.EXC.4/PP.ADJ.4)',
                    },
                  },
                  expressionProperties: {
                    //This is needed for datamasking
                    'props.options': (model, formState, field) => {
                      if (
                        field &&
                        field.parent &&
                        field.parent.parent &&
                        field.parent.parent.parent &&
                        field.parent.parent.parent.parent &&
                        field.parent.parent.parent.parent.model &&
                        field.parent.parent.parent.parent.model
                          .concentrationtypecode &&
                        field?.parent?.parent?.parent?.parent?.model
                          .concentrationtypecode.value == 0
                      ) {
                        return [{ code: '0', name: '***' }];
                      } else {
                        return this.injector
                          .get(LookupGetService)
                          .loadCachedOptions('amountprefix');
                      }
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
            {
              className: 'flex-1',
              key: 'lowamountnumerunit',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('amountnumerunit'),
                    label: 'Numerator Unit',
                    disabled: true,
                    readonly: true,
                    valueProp: 'code',
                    labelProp: 'name',
                    attributes: {
                      title:
                        'The Low Limit Numerator Unit or for non range measurements the Numerator Unit (PP.ACT.5/PP.EXC.5/PP.ADJ.5)',
                    },
                  },
                  expressionProperties: {
                    //This is needed for datamasking
                    'props.options': (model, formState, field) => {
                      if (
                        field &&
                        field.parent &&
                        field.parent.parent &&
                        field.parent.parent.parent &&
                        field.parent.parent.parent.parent &&
                        field.parent.parent.parent.parent.model &&
                        field.parent.parent.parent.parent.model
                          .concentrationtypecode &&
                        field?.parent.parent.parent.parent.model
                          .concentrationtypecode.value == 0
                      ) {
                        return [{ code: '0', name: '***' }];
                      } else {
                        return field!.props!['options'];
                      }
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
          ],
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              className: 'flex-1',
              type: 'masked-input',
              key: 'lowamountdenomvalue',
              props: {
                label: 'Denominator Value',
                disabled: true,
                readonly: true,
                maskChar: '*',
                maskIf: (field: any) => {
                  return (
                    field &&
                    field.parent &&
                    field.parent.parent &&
                    field.parent.parent.parent &&
                    field.parent.parent.parent.model.concentrationtypecode &&
                    field.parent.parent.parent.model.concentrationtypecode
                      .value == 0
                  );
                },
                attributes: {
                  title:
                    'The Low Limit Denominator Value or for non range measurements the Denominator Value (PP.ACT.6/PP.EXC.6/PP.ADJ.6)',
                },
              },
            },
            {
              className: 'flex-1',
              key: 'lowamountdenomprefix',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('amountprefix'),
                    label: 'Denominator Prefix',
                    disabled: true,
                    readonly: true,
                    valueProp: 'code',
                    labelProp: 'name',
                    attributes: {
                      title:
                        'The Low Limit Denominator Prefix or for non range measurements the Denominator Prefix (PP.ACT.7/PP.EXC.7/PP.ADJ.7)',
                    },
                  },
                  expressionProperties: {
                    //This is needed for datamasking
                    'props.options': (model, formState, field) => {
                      if (
                        field &&
                        field.parent &&
                        field.parent.parent &&
                        field.parent.parent.parent &&
                        field.parent.parent.parent.parent &&
                        field.parent.parent.parent.parent.model
                          .concentrationtypecode &&
                        field.parent.parent.parent.parent.model
                          .concentrationtypecode.value == 0
                      ) {
                        return [{ code: '0', name: '***' }];
                      } else {
                        return field!.props!['options'];
                      }
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
            {
              className: 'flex-1',
              key: 'lowamountdenomunit',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: [],
                    label: 'Denominator Unit',
                    disabled: true,
                    readonly: true,
                    valueProp: 'code',
                    labelProp: 'name',
                    attributes: {
                      title:
                        'The Low Limit Denominator Unit or for non range measurements the Denominator Unit (PP.ACT.8/PP.EXC.8/PP.ADJ.8)',
                    },
                  },
                  expressionProperties: {
                    'model.expressedAs': (
                      model,
                      formState,
                      field?: FormlyFieldConfig,
                    ) => {
                      const strengthControl =
                        field!.parent!.parent!.parent!.parent!.fieldGroup![3]
                          .get!('expressedAs').formControl;

                      let optionsToDisplay;
                      let lookUpValueSet = '';
                      if (strengthControl!.value == 1) {
                        lookUpValueSet = 'unitofmeasurement';
                        optionsToDisplay = this.injector
                          .get(LookupGetService)
                          .loadCachedOptions(lookUpValueSet);
                      } else if (strengthControl!.value == 2) {
                        lookUpValueSet = 'unitofpresentation';
                        optionsToDisplay = this.injector
                          .get(LookupGetService)
                          .loadCachedOptions(lookUpValueSet);
                      } else {
                        lookUpValueSet = '';
                        optionsToDisplay = [];
                      }

                      if (field!.props) {
                        if (
                          field &&
                          field.parent &&
                          field.parent.parent &&
                          field.parent.parent.parent &&
                          field.parent.parent.parent.parent &&
                          field.parent.parent.parent.parent.model
                            .concentrationtypecode &&
                          field.parent.parent.parent.parent.model
                            .concentrationtypecode.value == 0
                        ) {
                          field!.props.options = [{ code: 0, name: '***' }];
                        } else {
                          field!.props.options = optionsToDisplay;
                        }
                      }

                      return strengthControl!.value;
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      key: 'highAmountConditionalGroup',
      hideExpression: (model, formState, field) => {
        return field?.parent?.model.concentrationtypecode?.value != 2 || false;
      },
      fieldGroup: [
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              key: 'secondSectionLabel',
              className: 'flex-1',
              template: '<div>space reserved</div>',
            },
          ],
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              className: 'flex-1',
              type: 'input',
              key: 'highamountnumervalue',
              props: {
                label: 'Numerator Value',
                disabled: true,
                readonly: true,
                attributes: {
                  title:
                    'The High Limit Numerator Value - for Range values only (PP.ACT.9/PP.EXC.9/PP.ADJ.9)',
                },
              },
            },
            {
              className: 'flex-1',
              key: 'highamountnumerprefix',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('amountprefix'),
                    label: 'Numerator Prefix',
                    disabled: true,
                    readonly: true,
                    valueProp: 'code',
                    labelProp: 'name',
                    attributes: {
                      title:
                        'The High Limit Numerator Prefix - for Range values only (PP.ACT.10/PP.EXC.10/PP.ADJ.10)',
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
            {
              className: 'flex-1',
              key: 'highamountnumerunit',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('amountnumerunit'),
                    label: 'Numerator Unit',
                    valueProp: 'code',
                    labelProp: 'name',
                    readonly: true,
                    disabled: true,
                    attributes: {
                      title:
                        'The High Limit Numerator Unit - for Range values only (PP.ACT.11/PP.EXC.11/PP.ADJ.11)',
                    },
                  },
                  hooks: {
                    onInit: (field) => {
                      const lowamountnumerunit =
                        field.parent!.parent!.parent!.parent!.fieldGroup![4]
                          .fieldGroup![1].fieldGroup![2].fieldGroup![0]
                          .formControl;
                      lowamountnumerunit?.valueChanges.subscribe((value) => {
                        field.formControl?.setValue(value);
                      });

                      lowamountnumerunit?.setValue(lowamountnumerunit?.value);
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
          ],
        },
        {
          fieldGroupClassName: 'display-flex',
          fieldGroup: [
            {
              className: 'flex-1',
              type: 'input',
              key: 'highamountdenomvalue',
              props: {
                label: 'Denominator Value',
                required: true,
                disabled: true,
                attributes: {
                  title:
                    'The High Limit Denominator Value - for Range measurements the Denominator Value (PP.ACT.12/PP.EXC.12/PP.ADJ.12)',
                },
              },
              validators: {
                customValidator: {
                  expression: (c: any) => /^\d+(\.\d+)?$/.test(c.value),
                  message: () => 'Only numbers are allowed',
                },
              },

              hooks: {
                onInit: (field) => {
                  const lowamountdenomvalueFormControl =
                    field.parent!.parent!.parent!.fieldGroup![4].fieldGroup![2]
                      .fieldGroup![0].formControl;
                  lowamountdenomvalueFormControl?.valueChanges.subscribe(
                    (value) => {
                      field.formControl?.setValue(value);
                    },
                  );

                  lowamountdenomvalueFormControl?.setValue(
                    lowamountdenomvalueFormControl.value,
                  );
                },
              },
            },
            {
              className: 'flex-1',
              key: 'highamountdenomprefix',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: this.injector
                      .get(LookupGetService)
                      .loadCachedOptions('amountprefix'),
                    label: 'Denominator Prefix',
                    valueProp: 'code',
                    labelProp: 'name',
                    required: true,
                    disabled: true,
                    attributes: {
                      title:
                        'The High Limit Denominator Prefix - for Range values only (PP.ACT.13/PP.EXC.13/PP.ADJ.13)',
                    },
                  },
                  hooks: {
                    onInit: (field) => {
                      const lowamountdenomprefixFormControl =
                        field.parent!.parent!.parent!.parent!.fieldGroup![4]
                          .fieldGroup![2].fieldGroup![1].fieldGroup![0]
                          .formControl;
                      lowamountdenomprefixFormControl?.valueChanges.subscribe(
                        (value) => {
                          field.formControl?.setValue(value);
                        },
                      );

                      lowamountdenomprefixFormControl?.setValue(
                        lowamountdenomprefixFormControl?.value,
                      );
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
            {
              className: 'flex-1',
              key: 'highamountdenomunit',
              fieldGroup: [
                {
                  type: 'select',
                  key: 'value',
                  props: {
                    options: [],
                    label: 'Denominator Unit',
                    valueProp: 'code',
                    labelProp: 'name',
                    required: true,
                    disabled: true,
                    attributes: {
                      title:
                        'The High Limit Denominator Unit - for Range values only (PP.ACT.14/PP.EXC.14/PP.ADJ.14)',
                    },
                  },
                  expressionProperties: {
                    'model.expressedAs': (
                      model,
                      formState,
                      field?: FormlyFieldConfig,
                    ) => {
                      const strengthControl =
                        field!.parent!.parent!.parent!.parent!.fieldGroup![3]
                          .get!('expressedAs').formControl;

                      let optionsToDisplay;
                      let lookUpValueSet = '';
                      if (strengthControl!.value == 1) {
                        lookUpValueSet = 'unitofmeasurement';
                        optionsToDisplay = this.injector
                          .get(LookupGetService)
                          .loadCachedOptions(lookUpValueSet);
                      } else if (strengthControl!.value == 2) {
                        lookUpValueSet = 'unitofpresentation';
                        optionsToDisplay = this.injector
                          .get(LookupGetService)
                          .loadCachedOptions(lookUpValueSet);
                      } else {
                        lookUpValueSet = '';
                        optionsToDisplay = [];
                      }

                      if (field!.props) {
                        field!.props.options = optionsToDisplay;
                      }

                      return strengthControl!.value;
                    },
                  },
                },
                {
                  key: 'name',
                },
                {
                  key: 'resolutionmode',
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  olddrugIngredientItemFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'substancecode',
          fieldGroup: [
            {
              type: 'input',
              key: 'value',
              wrappers: ['modal-wrapper'],
              props: {
                label: 'Substance',
                lookup: {
                  name: 'substance',
                  description: 'Select Substance',
                  type: 'LR',
                  parameters: null,
                  columns: [
                    new ListColumn('Num', ListDataColumn.TEXT, 'num'),
                    new ListColumn('EV Code', ListDataColumn.TEXT, 'code'),
                    new ListColumn(
                      'Substance Name',
                      ListDataColumn.TEXT,
                      'name',
                    ),
                    new ListColumn('Type', ListDataColumn.TEXT, 'type'),
                    new ListColumn('Language', ListDataColumn.TEXT, 'language'),
                    new ListColumn(
                      'Validated',
                      ListDataColumn.DATE,
                      'validated',
                    ),
                  ],
                },
                disabled: true,
                readonly: true,
                attributes: {
                  title:
                    'The substance name of the ingredient(s) indicated as active/excipient/adjuvant in line with the description of the ingredients referenced in the SmPC must be specified as per guidance described in Chapter 3.II. (PP.ACT.1/PP.EXC.1/PP.ADJ.1)',
                },
              },
              expressions: {
                'props.lookup.parameters': (field: FormlyFieldConfig) => {
                  if (
                    this.injector.get(Art57Section).getSelectedSection()
                      .selectedNode.parent?.parent?.parent?.parent?.data.model
                      .type == 2
                  ) {
                    //Authorised
                    return [['type', 2]];
                  } else {
                    //Development
                    //No filters needed
                    return null;
                  }
                },
              },
            },
            {
              key: 'name',
            },
            {
              key: 'resolutionmode',
              defaultValue: 2,
            },
          ],
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'roleofingredient',
          type: 'radio',
          props: {
            label: 'Role of Ingredient',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('roleofingredient'),
            valueProp: 'code',
            labelProp: 'name',
            disabled: true,
            readonly: true,
            attributes: {
              title: 'Role of Ingredient (PP.ACT/PP.EXC/PP.ADJ)',
            },
          },
        },
        {
          key: 'name',
        },
        {
          key: 'resolutionmode',
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'concentrationtype',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Type of Concentration',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'concentrationunitcode',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Concentration Unit Code',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'concentration',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Concentration',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'concentration2',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Concentration 2 (range)',
            readonly: true,
            disabled: true,
          },
        },
      ],
    },
  ];

  xevprmMessageFields: FormlyFieldConfig[] = [
    {
      key: 'id',
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'localnumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Local Number',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Local Number',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'messagenumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Message Number',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Message Number',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'senderid',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Sender ID',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Sender ID',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'sendername',
          defaultValue: '',
          hide: true,
          type: 'input',
          props: {
            label: 'Sender Name',
            readonly: true,
            disabled: true
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'messagedate',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Message Date',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Message Date',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'messagereceivedate',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Message Receive Date',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Message Receive Date',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'docref',
          type: 'linkType', // this should be similar to documentViewType
          props: {
            label: 'EVPRM Message',
            endpoint: 'inboundmessage', // this will need to be set to the correct endpoint to view the ACK message
            service: MedicinalproductsService, // this should be the name of the service that will handle opening the link
            readonly: true,
            attributes: {
              title: 'Original Message XML File',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ackdate',
          type: 'input',
          props: {
            label: 'Message ACK Date',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Message ACK Date',
            },
          },
        },

        {
          className: 'flex-1',
          key: 'ackreceivedate',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Message ACK Receive Date',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Message ACK Receive Date (MF.10)',
            },
          },
        },
        {
          className: 'flex-1',
          key: 'ackdocref',
          type: 'linkType', // this should be similar to documentViewType
          props: {
            label: 'EVPRM Message ACK',
            endpoint: 'outboundmessage', // this will need to be set to the correct endpoint to view the ACK message
            service: MedicinalproductsService, // this should be the name of the service that will handle opening the link
            readonly: true,
            attributes: {
              title: 'Original ACK Message XML File',
            },
          },
        },
      ],
    },
  ];

  operationResultFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'entity',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Entity',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Entity',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'localnumber',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Local Number',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Local Number',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'ev_Code',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'EV Code',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'EV Code',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'operationtype',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Operation Type',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('operationtypeoperationresult'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Operation Type',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'operationresult',
          defaultValue: '',
          type: 'select',
          props: {
            label: 'Operation Result',
            options: this.injector
              .get(LookupGetService)
              .loadCachedOptions('operationresult'),
            valueProp: 'code',
            labelProp: 'name',
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Operation Result',
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'operationdate',
          defaultValue: '',
          type: 'input',
          props: {
            label: 'Operation Date',
            readonly: true,
            disabled: true,
            showFormat: false,
            attributes: {
              title: 'Operation Date',
            },
          },
        },
      ],
    },
     {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          className: 'flex-1',
          key: 'message',
          defaultValue: '',
          type: 'textarea',
          props: {
            label: 'Message',
            rows: 5,
            readonly: true,
            disabled: true,
            attributes: {
              title: 'Message',
            },
          },
        },
      ],
    },
  ];
}
